import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';
import React from 'react';
import ItemRow from '../ItemRow';
import { AvatarRadii } from 'components/Avatar';

export type Item = {
  id: string;
  name: string;
  photoUrl?: string;
};

interface Props {
  isLoading: boolean;
  items: Item[];
  onSelect: (item: Item) => void;
  selectedItems: Item[];
  search: string;
  onClearAll: () => void;
  lastElementRef?: (node: HTMLLIElement) => void;
  clearButtonText?: string;
  avatarRadius?: AvatarRadii;
  claimedUsers?: string[];
}

const ItemList = ({
  isLoading,
  items,
  onSelect,
  selectedItems,
  search,
  onClearAll,
  clearButtonText,
  lastElementRef,
  avatarRadius,
  claimedUsers
}: Props) => {
  if (!isLoading && items && items?.length === 0) {
    return (
      <div className="h-[30vh] flex flex-col items-center justify-center mt-6">
        <p className="text-base font-normal mt-4"> No Items Found </p>
      </div>
    );
  }
  const showClearButton = selectedItems.length > 0 && search === '';
  const hasClaimedUsers =
    claimedUsers && items?.some((item) => claimedUsers?.includes(item.id));
  return (
    <div className="w-full h-[30vh]">
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <Spinner type={SpinnerType.PRIMARY} />
        </div>
      ) : (
        <>
          {showClearButton && clearButtonText && (
            <div className="flex flex-row justify-between items-center rounded-full my-6">
              <p className="text-sm text-[#202020] font-bold">
                {clearButtonText}
              </p>
              <button
                type="button"
                className="text-sm font-normal text-[#3853C4] text-bold disabled:opacity-60 disabled:cursor-not-allowed"
                disabled={hasClaimedUsers}
                onClick={onClearAll}
              >
                Clear
              </button>
            </div>
          )}
          <ul className="flex flex-col gap-2">
            {items?.map((item) => (
              <ItemRow
                key={item.id}
                name={item.name}
                onSelect={() => onSelect(item)}
                id={item.id}
                image={item.photoUrl}
                isSelected={selectedItems.some(
                  (selectedItem) => selectedItem.id === item.id
                )}
                isDisabled={claimedUsers?.includes(item.id)}
                ref={lastElementRef}
                avatarRadius={avatarRadius}
                claimedUsers={claimedUsers}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default ItemList;
